var map = {
	"./AirtelDTH.png": "98f8",
	"./DishTV.png": "52eb",
	"./RelianceBigTv.png": "afe1",
	"./SunDirect.png": "ed73",
	"./TataSky.png": "0d08",
	"./VideoconD2H.png": "e5ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a473";